















import Vue, { CreateElement, VNode } from 'vue'
import { Map, Marker, LngLatLike, MarkerOptions, Popup, Point as Pt, PopupOptions } from 'mapbox-gl';
import { Feature, Point, GeoJsonProperties } from 'geojson';

import center from "@turf/center";

import MarkerView from "./MarkerView.vue"

export default Vue.extend({

	inject: ["$map"],

	components: {
		MarkerView
	},

	created() {

	},

	props: {
		marker: Object as () => Feature<Point>,
		hide: Boolean,
		passed: Boolean,
	},

	data() {
		return {
			popup: undefined as Popup|undefined,
		}
	},

	computed: {
		cat():string {
			return this.marker.properties!.cat;
		},

		arrow():Boolean {
			return this.marker.properties!.arrow == true || this.marker.properties!.arrow=='true'
		},

		center():LngLatLike {
			return center(this.marker).geometry.coordinates;
		},

		z():number {
			const z = this.marker.properties?.z;
			if(z != undefined)
				return z;
			return 1;
		},

		styles():object {
			return {
				'z-index': 1000000 + (1000000 * this.z) - Math.round(this.center[1]*10000),
			}
		}
	},

	methods: {
		updateMarker() {


			if(this.marker.geometry) {

				const anchor = this.marker.properties!.anchor || "center";
				const arrow = this.marker.properties!.arrow != undefined && this.marker.properties!.arrow != "false";

				//MARKER
				let options:MarkerOptions = {anchor}
				let marker = new Marker(this.$el as HTMLElement, options)
					.setLngLat(this.center)
					//.setPopup(this.popup)
					.addTo(this.$map);

				//POPUP
				let w = marker.getElement().offsetWidth/2;
				let h = marker.getElement().offsetHeight/2;

				let bigW = w * 1.7; // should get from css instead
				let bigH = h * 1.7;

				if(arrow) {
					w = bigW;
					h = bigH;
				}

				const offset:[number,number] = [0,0];
				if(anchor.indexOf("top") > -1)
					offset[1] = h;
				else if(anchor.indexOf("bottom") > -1)
					offset[1] = -h;
				if(anchor.indexOf("left") > -1)
					offset[0] = w;
				else if(anchor.indexOf("right") > -1)
					offset[0] = -w;

				const desc = this.marker.properties!.desc;
				if(desc) {
					let popupOptions:PopupOptions = {
						offset: {
							top: new Pt(...offset).add(new Pt(0,bigH)),
							bottom: new Pt(...offset).add(new Pt(0,-bigH)),
							left: new Pt(...offset).add(new Pt(bigW,0)),
							right: new Pt(...offset).add(new Pt(-bigW,0)),
						},
						closeButton: false,
					}
					if(this.cat == "city")
						popupOptions.anchor = this.arrow ? "right" : "left";
					this.popup = new Popup(popupOptions)

					.setLngLat(this.center)
					.setText(this.marker.properties!.desc)
				}
			}

		},

		mouseEnter(event) {
			if(this.popup && !this.hide)
				this.popup.addTo(this.$map);
			this.$emit("setProgress", this.marker.properties!.progress, "marker")
		},

		mouseLeave(event) {
			if(this.popup)
				this.popup.remove();
		},

		click(event) {
			event.stopPropagation();
		},

		mouseMove(event) {
			event.stopPropagation();
		}
	},

	mounted() {
		this.updateMarker();
	},

	watch: {
		"marker": {
			handler(n) {
				this.updateMarker();
			}
		}
	},
});

